module.exports = __webpack_public_path__ + "static/img/jieshao.477544a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jieshao.jpg
// module id = VQcz
// module chunks = 1